import { ArticleType } from '@nemuru-eng/js-api-client';
import { z } from 'zod';

import { MinimalFormItemSchema } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/schemas/MinimalFormItemSchema';
import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { requiredFutureDate, requiredString } from '@/utils/zodUtils';

export const AccommodationFormItemSchema = (t: GetTextIdTranslationType) =>
  MinimalFormItemSchema(t).merge(
    z
      .object({
        type: z.literal(ArticleType.ACCOMMODATION),
        description: z.string().optional(),
        establishmentName: requiredString(t),
        checkinDate: requiredFutureDate(t),
        checkoutDate: requiredFutureDate(t),
      })
      .strict(),
  );
